export default __webpack_public_path__ + "static/Tek_Claws-e046fdee3e11456c25673de73e2ba500.png";